import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { WorkflowService } from "../service/workflow.service";
import { S25ButtonComponent } from "../../../standalone/s25.button.component";
import { S25SecurityLinkModule } from "../../s25-security-link/s25.security.link.module";
import { Item } from "../../../pojo/Item";
import { WorkflowConst } from "../workflow.const";

@TypeManagerDecorator("s25-ng-workflow-admin")
@Component({
    selector: "s25-ng-workflow-admin",
    template: `
        @if (init) {
            <div>
                <p class="c-margin-bottom--single">
                    Click Initialize below to create a Workflow cabinet and folder structure. After initializing, visit
                    the Groups Tool to set up default OLS for Workflow assignments.
                </p>
                @if (alreadyInitialized) {
                    <div class="c-margin-bottom--single">
                        <p>Workflow has already been initialized.</p>
                        <div class="c-margin-top--single">
                            <p class="c-margin-bottom--half">Configure security for Workflow components:</p>
                            <div class="c-margin-bottom--half">
                                <s25-security-link
                                    [itemTypeId]="EVENT_TYPE_ID"
                                    [itemId]="WORKFLOW_CABINET_ID"
                                    [nodeType]="'C'"
                                >
                                </s25-security-link>
                                <span class="c-margin-left--half">Workflow Cabinet</span>
                            </div>
                            <div>
                                <s25-security-link
                                    [itemTypeId]="EVENT_TYPE_ID"
                                    [itemId]="WORKFLOW_FOLDER_ID"
                                    [nodeType]="'F'"
                                >
                                </s25-security-link>
                                <span class="c-margin-left--half">Workflow Folder</span>
                            </div>
                        </div>
                    </div>
                }
                <s25-ng-button [type]="'primary'" [onClick]="initialize">Initialize</s25-ng-button>
            </div>
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25ButtonComponent, S25SecurityLinkModule],
})
export class WorkflowAdminComponent implements OnInit {
    constructor(private cd: ChangeDetectorRef) {}

    alreadyInitialized = false;
    init = false;

    // Expose static constants for template use
    readonly EVENT_TYPE_ID = Item.Ids.Event;
    readonly WORKFLOW_CABINET_ID = WorkflowConst.WorkflowCabinetId;
    readonly WORKFLOW_FOLDER_ID = WorkflowConst.WorkflowFolderId;

    initialize = async () => {
        const result = await WorkflowService.initialize();
        this.alreadyInitialized = await this.isAlreadyInitialized();
        this.cd.detectChanges();
        return result;
    };

    isAlreadyInitialized = () => {
        return WorkflowService.isInitialized();
    };

    async ngOnInit() {
        this.alreadyInitialized = await this.isAlreadyInitialized();
        this.init = true;
        this.cd.detectChanges();
    }
}
